module.exports = __webpack_public_path__ + "static/media/boat.80268f72.svg";